import ExpandLessRoundedIcon from "@mui/icons-material/ExpandLessRounded";

export const expandLess = ({ size = 15, color = "white" }) => {
  return <ExpandLessRoundedIcon />;
};
